const s = {
  name: "Direction",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27.8,12.2l-3.5,12.2l-12.2,3.5l3.5-12.2L27.8,12.2z M17,18.4l-1.9,6.5l6.5-1.9L17,18.4z M23,21.6l1.9-6.5
			L18.4,17L23,21.6z"/>
		<path class="st0" d="M0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0C9,0,0,9,0,20z M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18
			S2,29.9,2,20S10.1,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Direction
};
